// src/components/CoordinateConversionWidget.jsx
import { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const CoordinateConversionWidget = ({ view }) => {
  useEffect(() => {
    if (!view || !view.ui) return;

    let coordinateWidget, expandWidget;

    loadModules([
      'esri/widgets/CoordinateConversion',
      'esri/widgets/Expand'
    ]).then(([CoordinateConversion, Expand]) => {
      coordinateWidget = new CoordinateConversion({
        view
      });

      expandWidget = new Expand({
        expandTooltip: "Coordinates",
        view,
        content: coordinateWidget,
        expandIconClass: 'esri-icon-applications',
        expanded: false
      });

      view.ui.add(expandWidget, {position: 'top-left', index: 5});
    });

    return () => {
      if (expandWidget && view?.ui) {
        view.ui.remove(expandWidget);
        expandWidget.destroy();
      }
      if (view?.map && coordinateWidget) {
        coordinateWidget.destroy();
      }
    };
  }, [view]);

  return null;
};

export default CoordinateConversionWidget;
